export default __webpack_public_path__ + "static/storm-cleanup-icon-e8794111363c69067f6079b5aeaa7133.png";